import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

const About = () => {
    return (
        <>
            <Navbar></Navbar>
            <section className="mrg_tb">
                <div className="container">

                    <div className="heading d-flex flex-column justify-content-center align-items-center mb-4">
                        <h2 className="Viga text-center  wow animate__flash" data-wow-delay="0s" data-wow-duration="1s">About Us<span className="cl-theme"></span></h2>
                    </div>

                    <div className="row d-flex justify-content-center align-items-center">
                        <div className="col-lg-6 my-3 my-lg-0 d-flex justify-content-center justify-content-lg-start wow animate__fadeInUp" data-wow-delay="0s" data-wow-duration="1s">
                            <img src="/images/About_Us_Page_Image.png" alt="Image of About Us Page" draggable="false" className="img-fluid" />
                        </div>
                        <div className="col-lg-6 my-3 my-lg-0 wow animate__fadeInLeft" data-wow-delay="0.5s" data-wow-duration="1s">
                            <h2 className="Viga">Who we are<span className="cl-theme"></span></h2>
                            <div className="cusLineH mt-2">
                                Integro EXIM is a dynamic and forward-thinking import-export
                                company, dedicated to facilitating global trade by connecting
                                businesses with high quality products from around the world.
                                With a strong commitment to excellence and innovation, we
                                specialize in sourcing, exporting and importing a wide range
                                of goods across diverse industries, ensuring our clients receive
                                the best products, services, and solutions to meet their needs.
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="mrg_tb">
                <div className="container">
                    <div className="row d-flex justify-content-center align-items-center">
                        <div className="col-lg-6 my-3 my-lg-0 order-1 order-lg-0 wow animate__fadeInRight" data-wow-delay="0.5s" data-wow-duration="1s">
                            <h2 className="Viga">Our story<span className="cl-theme"></span></h2>
                            <div className="cusLineH mt-2">
                                Founded in 2024, Integro EXIM was established with a vision to
                                simplify and streamline the complexities of international trade.
                                Our deep understanding of both local and international markets
                                enables us to navigate the intricacies of trade regulations, tariffs,
                                and compliance, ensuring smooth and efficient transactions.
                            </div>
                        </div>
                        <div className="col-lg-6 my-3 my-lg-0 order-0 order-lg-1 d-flex justify-content-center justify-content-lg-end wow animate__fadeInUp" data-wow-delay="0s" data-wow-duration="1s">
                            <img src="/images/Our_Story_Image.png" alt="Image of Our Story section" draggable="false" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="mrg_tb">
                <div className="NumFixBG">
                    <div className="container">


                        <div className="heading d-flex flex-column justify-content-center align-items-center mb-4">
                            <h2 className="Viga text-center wow animate__flash" data-wow-delay="0s" data-wow-duration="1s">Why Choose us<span className="cl-theme">?</span></h2>
                            <div className="subHeading wow animate__fadeInDown" data-wow-delay="0.6s" data-wow-duration="1s">
                                Our global network spans multiple countries, including India, with a wide range of markets where we conduct business.
                            </div>
                        </div>

                        <div className="row">

                            <div className="col-md-6 my-3  wow animate__fadeInUp" data-wow-delay="0.4s" data-wow-duration="1s">
                                <div className="ChooseCard">
                                    <img src="/images/Vision.png" alt="Image of Vision" draggable="false" className="img-fluid chooseIcon" />
                                    <h5 className="Viga mt-3 mb-2">Vision</h5>
                                    <div className="chooseText">
                                        "To be a trusted global leader in international trade, seamlessly connecting markets and fostering economic growth through responsible, efficient, and innovative import-export solutions."
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-6 my-3  wow animate__fadeInUp" data-wow-delay="0.6s" data-wow-duration="1s">
                                <div className="ChooseCard">
                                    <img src="/images/Mission.png" alt="Image of Mission" draggable="false" className="img-fluid chooseIcon" />
                                    <h5 className="Viga mt-3 mb-2">Mission</h5>
                                    <div className="chooseText">
                                        "Our mission is to deliver high-quality products and exceptional import-export services to our clients across the globe. We are committed to ensuring reliable, efficient, and compliant logistics solutions, while fostering strong partnerships and upholding the highest standards of integrity, innovation, and customer satisfaction in international trade."
                                    </div>

                                </div>
                            </div>

                        </div>


                    </div>
                </div>
            </section>

            <section className="mrg_tb">
                <div className="container">
                    <div className="row d-flex justify-content-center align-items-center">
                        <div className="col-lg-6 my-3 my-lg-0 d-flex justify-content-center justify-content-lg-start wow animate__fadeInUp" data-wow-delay="0s" data-wow-duration="1s">
                            <img src="/images/About_Us_Image.png" alt="Image of About Us section" draggable="false" className="img-fluid" />
                        </div>
                        <div className="col-lg-6 my-3 my-lg-0  wow animate__fadeInLeft" data-wow-delay="0.5s" data-wow-duration="1s">
                            <h2 className="Viga">Our Values<span className="cl-theme"></span></h2>
                            <div className="cusLineH mt-2 pb-5">
                                At the core of our business are integrity, reliability, and customer
                                satisfaction. We take pride in building long-term relationships
                                with our clients, partners, and suppliers based on trust,
                                transparency, and mutual success. Our team of experienced
                                professionals works tirelessly to provide tailored solutions,
                                ensuring timely deliveries, competitive pricing, and seamless
                                logistics, no matter the destination
                            </div>
                            <h2 className="Viga">Our Commitment<span className="cl-theme"></span></h2>
                            <div className="cusLineH mt-2 pb-5">
                                We are committed to fostering growth and success for our
                                clients through reliable and efficient importexport services.
                                Whether you are a small business looking to expand into new
                                markets or a large corporation seeking dependable trade
                                solutions, Integro EXIM is your trusted partner in international
                                trade.
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="mrg_tb">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 my-3 my-lg-0  wow animate__fadeInUp" data-wow-delay="0.4s" data-wow-duration="1s">
                            <div className="bankDetailsBox">
                                <h2 className="Viga pb-3">Bank Details<span className="cl-theme"></span></h2>
                                <div className="mt-3"><span className="fw-semi f-18">Bank Name :</span>  HDFC Bank</div>
                                <div className="mt-3"><span className="fw-semi f-18">Name :</span>  INTEGRO EXIM</div>
                                <div className="mt-3"><span className="fw-semi f-18">Account Type :</span>  Current Account</div>
                                <div className="mt-3"><span className="fw-semi f-18">Account Number :</span>  50200102250770</div>
                                <div className="mt-3"><span className="fw-semi f-18">IFSC Code :</span>  HDFC0005894</div>
                            </div>
                        </div>
                        <div className="col-lg-6 my-3 my-lg-0  wow animate__fadeInUp" data-wow-delay="0.6s" data-wow-duration="1s">
                            <div className="bankDetailsBox">
                                <h2 className="Viga pb-3">Certification<span className="cl-theme"></span></h2>
                                <div className="mt-3"><span className="fw-semi f-18">GSTIN :</span>  24AAKFI9163L1ZV</div>
                                <div className="mt-3"><span className="fw-semi f-18">IEC :</span>  AAKFI9163L</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="mrg_tb">
                <div className="container">

                    <div className="heading d-flex flex-column justify-content-center align-items-center mb-4">
                        <h2 className="Viga text-center  wow animate__flash" data-wow-delay="0s" data-wow-duration="1s">Associates<span className="cl-theme"></span></h2>
                    </div>

                    {/* <!-- <marquee >
            <div className="d-flex justify-content-between align-items-center cusGap">
                <div className="d-flex flex-column justify-content-center align-items-center  AssociatesLogo">
                    <img src="/images/AssociatesLogos/HDFC Bank.png" alt="Logo of HDFC Bank" draggable="false" className="img-fluid ">
                    <div className="fw-medi mt-2">( Bank )</div>
                </div>
                <div className="d-flex flex-column justify-content-center align-items-center  AssociatesLogo">
                    <img src="/images/AssociatesLogos/FIEO.png" alt="Logo of FIEO" draggable="false" className="img-fluid ">
                    <div className="fw-medi mt-2">(Membership)</div>
                </div>
                <div className="d-flex flex-column justify-content-center align-items-center  AssociatesLogo">
                    <img src="/images/AssociatesLogos/APEDA.png" alt="Logo of APEDA" draggable="false" className="img-fluid ">
                    <div className="fw-medi mt-2">(Membership)</div>
                </div>
                <div className="d-flex flex-column justify-content-center align-items-center  AssociatesLogo">
                    <img src="/images/AssociatesLogos/Spices Board.png" alt="Logo of Spices Board" draggable="false" className="img-fluid ">
                    <div className="fw-medi mt-2">(Membership)</div>
                </div>
                <div className="d-flex flex-column justify-content-center align-items-center  AssociatesLogo">
                    <img src="/images/AssociatesLogos/Fssai.png" alt="Logo of Fssai" draggable="false" className="img-fluid ">
                    <div className="fw-medi mt-2">(Licence)</div>
                </div>
            </div>
        </marquee> --> */}


                    <div className="row d-flex justify-content-center justify-content-md-between align-items-center">
                        <div className="my-3 my-md-0 p-3 p-sm-4 p-md-2 col-4 col-md-2 d-flex flex-column justify-content-center align-items-center  wow animate__fadeInUp" data-wow-delay="0.1s" data-wow-duration="1s">
                            <img src="/images/AssociatesLogos/HDFC Bank.png" alt="Logo of HDFC Bank" draggable="false" className="img-fluid " />
                            <div className="fw-medi mt-2 AssociatesFont">(Bank)</div>
                        </div>
                        <div className="my-3 my-md-0 p-3 p-sm-4 p-md-2 col-4 col-md-2 d-flex flex-column justify-content-center align-items-center  wow animate__fadeInUp" data-wow-delay="0.2s" data-wow-duration="1s">
                            <img src="/images/AssociatesLogos/FIEO.png" alt="Logo of FIEO" draggable="false" className="img-fluid " />
                            <div className="fw-medi mt-2 AssociatesFont">(Membership)</div>
                        </div>
                        <div className="my-3 my-md-0 p-3 p-sm-4 p-md-2 col-4 col-md-2 d-flex flex-column justify-content-center align-items-center  wow animate__fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                            <img src="/images/AssociatesLogos/APEDA.png" alt="Logo of APEDA" draggable="false" className="img-fluid " />
                            <div className="fw-medi mt-2 AssociatesFont">(Membership)</div>
                        </div>
                        <div className="my-3 my-md-0 p-3 p-sm-4 p-md-2 col-4 col-md-2 d-flex flex-column justify-content-center align-items-center  wow animate__fadeInUp" data-wow-delay="0.4s" data-wow-duration="1s">
                            <img src="/images/AssociatesLogos/Spices Board.png" alt="Logo of Spices Board" draggable="false" className="img-fluid " />
                            <div className="fw-medi mt-2 AssociatesFont">(Membership)</div>
                        </div>
                        <div className="my-3 my-md-0 p-3 p-sm-4 p-md-2 col-4 col-md-2 d-flex flex-column justify-content-center align-items-center  wow animate__fadeInUp" data-wow-delay="0.5s" data-wow-duration="1s">
                            <img src="/images/AssociatesLogos/Fssai.png" alt="Logo of Fssai" draggable="false" className="img-fluid " />
                            <div className="fw-medi mt-2 AssociatesFont">(Licence)</div>
                        </div>
                    </div>

                </div>
            </section>
            <Footer></Footer>
        </>
    )
}

export default About